/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Option_Day_TodayInputs */

const vi_lot_option_day_today = /** @type {(inputs: Lot_Option_Day_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hôm nay`)
};

/**

* @param {Lot_Option_Day_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_option_day_today = /** @type {((inputs?: Lot_Option_Day_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Option_Day_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_option_day_today(inputs)
});